import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionStatus } from "../../../autogen/bff-api";

export const QuestionStatusBadge = ({ status }: { status: SeV2QuestionStatus }) => {
  const { t } = useTranslation();
  switch (status) {
    case SeV2QuestionStatus.Unanswered:
      return (
        <Badge colorScheme="red" variant="subtle">
          {t("Unanswered")}
        </Badge>
      );
    case SeV2QuestionStatus.Answered:
      return (
        <Badge colorScheme="blue" variant="subtle">
          {t("Answered")}
        </Badge>
      );
    case SeV2QuestionStatus.Published:
      return (
        <Badge colorScheme="green" variant="subtle">
          {t("Published")}
        </Badge>
      );
  }
};
